import { Vacancy } from '../types/VacancyTypes';

export interface VacancyTags {
  department: string;
  seniority: string;
  workStyle: string;
  employmentType: string;
}

const DEPARTMENT_RULES: [RegExp, string][] = [
  [/engineer|developer|swe|backend|frontend|fullstack|full-stack|devops|sre|infrastructure|platform|software|embedded|firmware|mobile dev/i, 'Engineering'],
  [/data\s?(scientist|engineer|analy)|machine learning|ml\b|ai\b|deep learning|analytics/i, 'Data'],
  [/product\s?(manager|owner|lead|director|vp)|pm\b/i, 'Product'],
  [/design|ux|ui\b|user experience|user interface|graphic|creative director/i, 'Design'],
  [/marketing|growth|seo|sem|content\s?(market|strat)|brand|demand gen|social media/i, 'Marketing'],
  [/sales|account\s?exec|bdr|sdr|business develop|revenue|partnerships/i, 'Sales'],
  [/finance|accounting|controller|treasury|financial analyst|cfo|bookkeeper/i, 'Finance'],
  [/human\s?resource|hr\b|people\s?(ops|partner|manager)|talent\s?(acqui|recruit)|recruiter/i, 'HR'],
  [/operations|ops\b|supply chain|logistics|procurement|warehouse/i, 'Operations'],
  [/legal|counsel|compliance|regulatory|attorney|lawyer|paralegal/i, 'Legal'],
  [/customer\s?(success|support|service)|support\s?engineer|help\s?desk|technical\s?support/i, 'Support'],
];

const SENIORITY_RULES: [RegExp, string][] = [
  [/\b(c-suite|ceo|cto|cfo|coo|cmo|cio|chief)\b/i, 'C-Level'],
  [/\b(vp|vice\s?president)\b/i, 'VP'],
  [/\b(director)\b/i, 'Director'],
  [/\b(manager|engineering\s?manager|team\s?lead)\b/i, 'Manager'],
  [/\b(principal|staff|lead|iii)\b/i, 'Lead'],
  [/\b(sr\.?|senior|ii)\b/i, 'Senior'],
  [/\b(mid[- ]?level)\b/i, 'Mid'],
  [/\b(jr\.?|junior|associate|entry[- ]?level|i\b)\b/i, 'Junior'],
  [/\b(intern|internship|co-?op|apprentice)\b/i, 'Intern'],
];

function detectDepartment(text: string): string {
  for (const [pattern, dept] of DEPARTMENT_RULES) {
    if (pattern.test(text)) return dept;
  }
  return 'Other';
}

function detectSeniority(title: string): string {
  for (const [pattern, level] of SENIORITY_RULES) {
    if (pattern.test(title)) return level;
  }
  return 'Mid';
}

function detectWorkStyle(vacancy: Vacancy): string {
  if (vacancy.is_remote) return 'Remote';
  const text = `${vacancy.title} ${vacancy.description}`.toLowerCase();
  if (/hybrid/i.test(text)) return 'Hybrid';
  return 'On-site';
}

export function autoLabel(vacancy: Vacancy): VacancyTags {
  const text = `${vacancy.title} ${vacancy.description}`;
  return {
    department: detectDepartment(text),
    seniority: detectSeniority(vacancy.title),
    workStyle: detectWorkStyle(vacancy),
    employmentType: vacancy.employment_type,
  };
}
